import { TimelineMax } from 'gsap'

const createTimelineFadeAnimation = ({ elementIds, ...options }) =>
  new TimelineMax(options).staggerFromTo(
    elementIds,
    0.25,
    { opacity: 0, y: 10 },
    { opacity: 1, y: 0 },
    0.1,
  )

const createEnterAnim = utils =>
  new TimelineMax().fromTo(
    utils.target,
    0.2,
    { opacity: 0, y: 10 },
    { opacity: 1, y: 0, delay: utils.options.delay },
  )

const searchHistoryPanelAnimation = elementId =>
  new TimelineMax({ paused: true }).fromTo(
    elementId,
    0.5,
    { x: 0 },
    { x: -300 },
  )

export default {
  createTimelineFadeAnimation,
  createEnterAnim,
  searchHistoryPanelAnimation,
}



// WEBPACK FOOTER //
// ./src/utils/animations/index.js